// src/locales/ta/stockAdjustment.js
export const stockAdjustment = {
  // Page titles
  createStockAdjustment: 'சரக்கு சரிசெய்தலை உருவாக்கவும்',
  editStockAdjustment: 'சரக்கு சரிசெய்தலைத் திருத்தவும்',
  stockAdjustmentDetails: 'சரக்கு சரிசெய்தல் விவரங்கள்',
  backToStockAdjustments: 'சரக்கு சரிசெய்தல்களுக்கு திரும்பவும்',
  allStockAdjustments: 'அனைத்து சரக்கு சரிசெய்தல்கள்',
  pageDescription: 'கையிருப்பு வேறுபாடுகளுக்காக சரக்கு அளவுகளைச் சரிசெய்க',
  detailsPageDescription: 'சரக்கு சரிசெய்தல் விவரங்களைப் பார்க்கவும் மற்றும் மேலாண்மை செய்யவும்',

  // Form sections
  selectWarehouse: 'கிடங்கைத் தேர்ந்தெடுக்கவும்',
  addItems: 'உருப்படிகளைச் சேர்க்கவும்',
  adjustmentItems: 'சரிசெய்தல் உருப்படிகள்',

  // Warehouse selection
  warehouse: 'கிடங்கு',
  warehouseRequired: 'கிடங்கு தேவை',
  selectWarehousePlaceholder: 'கிடங்கைத் தேர்ந்தெடுக்கவும்',
  allWarehouses: 'அனைத்து கிடங்குகளும்',

  // Existing adjustments dialog
  existingAdjustments: 'தற்போதைய வரைவு சரிசெய்தல்கள்',
  existingAdjustmentsMessage: 'இன்று உங்களுக்கு வரைவு சரிசெய்தல்கள் உள்ளன. நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?',
  continueWith: 'தொடரவும்',
  startNewAdjustment: 'புதிய சரிசெய்தலைத் தொடங்கவும்',
  selectAdjustment: 'சரிசெய்தலைத் தேர்ந்தெடுக்கவும்',

  // Product search
  searchProducts: 'தயாரிப்புகளைத் தேடவும்',
  searchProductsPlaceholder: 'பெயர், SKU, அல்லது பார்கோடு மூலம் தேடவும்...',
  noProductsFound: 'தயாரிப்புகள் எதுவும் கிடைக்கவில்லை',
  searchingProducts: 'தேடப்படுகிறது...',
  currentStock: 'தற்போதைய சரக்கு',
  searchItems: 'உருப்படிகளைத் தேடவும்...',
  searchPlaceholder: 'சரிசெய்தல் எண் மூலம் தேடவும்...',

  // Add item form
  addItemTitle: 'சரிசெய்தலில் உருப்படியைச் சேர்க்கவும்',
  editItemTitle: 'சரிசெய்தல் உருப்படியைத் திருத்தவும்',
  productName: 'தயாரிப்பு',
  recordedCount: 'பதிவு செய்யப்பட்ட அளவு',
  physicalCount: 'உண்மையான அளவு',
  physicalCountRequired: 'உண்மையான அளவு தேவை',
  physicalCountMinimum: 'உண்மையான அளவு 0 அல்லது அதற்கு மேல் இருக்க வேண்டும்',
  variance: 'வேறுபாடு',
  notes: 'குறிப்புகள்',
  notesPlaceholder: 'இந்த உருப்படிக்கான குறிப்புகளைச் சேர்க்கவும்...',
  addItem: 'உருப்படியைச் சேர்க்கவும்',
  updateItem: 'உருப்படியை புதுப்பிக்கவும்',
  cancel: 'ரத்துசெய்',

  // Items table
  itemNumber: '#',
  itemProduct: 'தயாரிப்பு',
  itemRecordedCount: 'பதிவு',
  itemPhysicalCount: 'உண்மை',
  itemVariance: 'வேறுபாடு',
  itemNotes: 'குறிப்புகள்',
  itemActions: 'செயல்கள்',
  edit: 'திருத்து',
  delete: 'அழி',

  // Summary
  totalItems: 'மொத்த உருப்படிகள்',
  totalVariance: 'மொத்த வேறுபாடு',
  noItemsAdded: 'இன்னும் உருப்படிகள் சேர்க்கப்படவில்லை',
  addItemsToAdjustment: 'இந்த சரக்கு சரிசெய்தலுக்கு உருப்படிகளைத் தேடி சேர்க்கவும்',
  items: 'உருப்படிகள்',
  item: 'உருப்படி',
  ofItems: '{{total}} உருப்படிகளில்',

  // Actions
  finalizeAdjustment: 'சரிசெய்தலை இறுதிசெய்',
  confirmFinalize: 'இறுதிசெய்வது சரக்கு அளவுகளை நிரந்தரமாகப் புதுப்பிக்கும். இதை மீட்டமைக்க முடியாது. நீங்கள் தொடர விரும்புகிறீர்களா?',
  confirmFinalizeTitle: 'சரக்கு சரிசெய்தலை இறுதிசெய்',
  confirmDelete: 'இந்த உருப்படியை நீக்க விரும்புகிறீர்களா?',
  finalize: 'இறுதிசெய்',
  print: 'அச்சிடு',
  exportCSV: 'CSV க்கு ஏற்றுமதி செய்',

  // Status messages
  adjustmentCreated: 'சரக்கு சரிசெய்தல் {{adjustmentNumber}} வெற்றிகரமாக உருவாக்கப்பட்டது',
  itemAdded: 'உருப்படி வெற்றிகரமாக சேர்க்கப்பட்டது',
  itemUpdated: 'உருப்படி வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  itemDeleted: 'உருப்படி வெற்றிகரமாக நீக்கப்பட்டது',
  adjustmentFinalized: 'சரக்கு சரிசெய்தல் இறுதிசெய்யப்பட்டு சரக்கு புதுப்பிக்கப்பட்டது',
  duplicateItem: 'இந்த தயாரிப்பு ஏற்கனவே இந்த சரிசெய்தலில் சேர்க்கப்பட்டுள்ளது',

  // Error messages
  failedToLoadWarehouses: 'கிடங்குகளை ஏற்ற முடியவில்லை',
  failedToLoadAdjustments: 'சரக்கு சரிசெய்தல்களை ஏற்ற முடியவில்லை',
  failedToSearchProducts: 'தயாரிப்புகளைத் தேட முடியவில்லை',
  failedToAddItem: 'உருப்படியைச் சேர்க்க முடியவில்லை',
  failedToUpdateItem: 'உருப்படியை புதுப்பிக்க முடியவில்லை',
  failedToDeleteItem: 'உருப்படியை நீக்க முடியவில்லை',
  failedToFinalize: 'சரிசெய்தலை இறுதிசெய்ய முடியவில்லை',
  noItemsToFinalize: 'இறுதிசெய்வதற்கு முன் குறைந்தது ஒரு உருப்படியைச் சேர்க்கவும்',
  failedToLoad: 'சரக்கு சரிசெய்தலை ஏற்ற முடியவில்லை',
  adjustmentNotFound: 'சரக்கு சரிசெய்தல் கிடைக்கவில்லை',
  goBackToList: 'பட்டியலுக்கு திரும்பவும்',

  // Validation
  pleaseSelectWarehouse: 'முதலில் கிடங்கைத் தேர்ந்தெடுக்கவும்',
  atLeastOneItemRequired: 'குறைந்தது ஒரு உருப்படி தேவை',

  // Loading states
  loadingWarehouses: 'கிடங்குகள் ஏற்றப்படுகிறது...',
  loadingAdjustments: 'சரிசெய்தல்கள் ஏற்றப்படுகிறது...',
  loadingProducts: 'தயாரிப்புகள் ஏற்றப்படுகிறது...',
  addingItem: 'உருப்படி சேர்க்கப்படுகிறது...',
  updatingItem: 'உருப்படி புதுப்பிக்கப்படுகிறது...',
  deletingItem: 'உருப்படி நீக்கப்படுகிறது...',
  finalizing: 'சரிசெய்தல் இறுதிசெய்யப்படுகிறது...',
  loadingDetails: 'சரிசெய்தல் விவரங்கள் ஏற்றப்படுகிறது...',

  // Adjustment info
  adjustmentNumber: 'சரிசெய்தல் எண்',
  adjustmentDate: 'சரிசெய்தல் தேதி',
  createdBy: 'உருவாக்கியவர்',
  finalizedBy: 'இறுதிசெய்தவர்',
  status: 'நிலை',
  statusDraft: 'வரைவு',
  statusFinalized: 'இறுதிசெய்யப்பட்டது',
  allStatuses: 'அனைத்து நிலைகளும்',

  // Keyboard shortcuts
  keyboardShortcuts: 'விசைப்பலகை குறுக்குவழிகள்',
  focusSearch: 'தேடலில் கவனம் செலுத்தவும்',
  clearSearch: 'தேடலை அழிக்கவும்',
  submitForm: 'படிவத்தைச் சமர்ப்பிக்கவும்',

  // Variance display
  variancePositive: 'அதிகப்படியானது',
  varianceNegative: 'குறைவு',
  varianceZero: 'மாற்றமில்லை',

  // Common
  sku: 'SKU',
  barcode: 'பார்கோடு',
  quantity: 'அளவு',
  loading: 'ஏற்றப்படுகிறது...',
  save: 'சேமி',
  close: 'மூடு',
  confirm: 'உறுதி செய்',
  confirmAction: 'இறுதிசெய்தலை உறுதி செய்',
  yes: 'ஆம்',
  no: 'இல்லை',
  total: 'மொத்தம்',
  unknownProduct: 'அறியப்படாத தயாரிப்பு',
  noMatch: 'பொருந்தவில்லை',
  recorded: 'பதிவு',
  physical: 'உண்மை',
  product: 'தயாரிப்பு',
  addedOn: 'சேர்க்கப்பட்ட தேதி',
  tryAdjustingSearch: 'உங்கள் தேடல் அளவுருக்களை மாற்றிப் பார்க்கவும்',
  dateRange: 'தேதி வரம்பு',

  // Empty states
  noAdjustmentsFound: 'சரக்கு சரிசெய்தல்கள் எதுவும் கிடைக்கவில்லை',
  noAdjustmentsFoundDescription: 'உங்கள் தற்போதைய வடிகட்டலுக்கு பொருந்தும் சரிசெய்தல்கள் இல்லை. தேடலை மாற்றிப் பார்க்கவும்.',
  noAdjustmentsYet: 'இன்னும் சரக்கு சரிசெய்தல்கள் இல்லை',
  noAdjustmentsYetDescription: 'கையிருப்பு வேறுபாடுகளை கண்காணிக்க உங்கள் முதல் சரக்கு சரிசெய்தலை உருவாக்கவும்.',
  createFirstAdjustment: 'முதல் சரக்கு சரிசெய்தலை உருவாக்கவும்',
};
